export type ListFilterValue = string | number | boolean | null | undefined;

export type ListFilterValues = Record<string, ListFilterValue>;

export interface ListFilterField {
  key: string;
  label: string;
}

/** Stable cache / query key fragment from applied filter values. */
export function buildListFiltersKey(filters: object): string {
  const record = filters as ListFilterValues;
  return Object.keys(record)
    .sort()
    .map((key) => {
      const value = record[key];
      if (value == null || value === "") return `${key}:`;
      return `${key}:${String(value)}`;
    })
    .join("|");
}

export function countActiveListFilters(filters: object): number {
  return Object.values(filters as ListFilterValues).filter(
    (value) => value != null && value !== "",
  ).length;
}
